export { MachidukuriPage as default } from '@/components/pages/News/Machidukuri'